export default __webpack_public_path__ + "static/media/server-error.25a19818.png";